/* Contenido del portafolio (ES/EN), tomado de las páginas del design system rivplay.
   Las imágenes y enlaces de los proyectos vienen de Firestore (lib/firebaseProjects.js). */

export const LINKS = {
  "github": "https://github.com/riveros0302",
  "linkedin": "https://www.linkedin.com/in/bryan-riveros-paredes/",
  "whatsapp": "https://wa.me/56997946083",
  "cv": "/cv-bryan-riveros.pdf",
  "email": "riveros.bryan@gmail.com"
};

export const UPLOAD = {
  "es": {
    "title": "Mini caso: subida de archivos con URLs firmadas",
    "before": {
      "steps": [
        {
          "icon": "phone",
          "text": "El frontend enviaba el archivo completo al backend."
        },
        {
          "icon": "server",
          "text": "El backend lo recibía, lo procesaba y lo subía a Cloud Storage."
        },
        {
          "icon": "hourglass",
          "text": "Cada subida ocupaba memoria y tiempo del servidor."
        }
      ]
    },
    "after": {
      "steps": [
        {
          "icon": "key",
          "text": "El backend entrega una URL firmada de corta duración."
        },
        {
          "icon": "upload",
          "text": "El frontend sube el archivo directo a Cloud Storage."
        },
        {
          "icon": "database",
          "text": "El backend solo recibe y guarda los datos del registro."
        }
      ]
    },
    "result": "Menos carga en el servidor y subidas más rápidas."
  },
  "en": {
    "title": "Mini case: file uploads with signed URLs",
    "before": {
      "steps": [
        {
          "icon": "phone",
          "text": "The frontend sent the whole file to the backend."
        },
        {
          "icon": "server",
          "text": "The backend received it, processed it and uploaded it to Cloud Storage."
        },
        {
          "icon": "hourglass",
          "text": "Every upload used server memory and time."
        }
      ]
    },
    "after": {
      "steps": [
        {
          "icon": "key",
          "text": "The backend returns a short-lived signed URL."
        },
        {
          "icon": "upload",
          "text": "The frontend uploads the file straight to Cloud Storage."
        },
        {
          "icon": "database",
          "text": "The backend only receives and stores the record data."
        }
      ]
    },
    "result": "Less load on the server and faster uploads."
  }
};

export const T = {
  "es": {
    "nav": [
      {
        "href": "#proyectos",
        "label": "Proyectos"
      },
      {
        "href": "#experiencia",
        "label": "Experiencia"
      },
      {
        "href": "#stack",
        "label": "Stack"
      },
      {
        "href": "#contacto",
        "label": "Contacto"
      }
    ],
    "cv": "Descargar CV",
    "status": "Disponible para nuevos proyectos",
    "heroA": "Construyo",
    "heroEm": "productos completos",
    "heroB": ", del frontend al backend.",
    "heroSub": "Full Stack Developer con base sólida en backend. React, React Native, NestJS y Google Cloud.",
    "ctaProjects": "Ver proyectos",
    "ctaContact": "Contactar",
    "heroMeta": [
      "React",
      "React Native",
      "NestJS",
      "TypeScript",
      "Google Cloud"
    ],
    "stats": [
      {
        "value": "Web · Mobile · Backend",
        "label": "Full stack real: interfaz, app y API."
      },
      {
        "value": "2 apps y 1 juego",
        "label": "publicados en tiendas."
      },
      {
        "value": "Google Cloud",
        "label": "Proyectos en producción en Cloud Run, Cloud SQL y Cloud Storage."
      },
      {
        "value": "2+ años",
        "label": "de experiencia en desarrollo."
      }
    ],
    "aboutEyebrow": "Sobre mí",
    "aboutTitle": "Full stack de producto: interfaz, API e infraestructura.",
    "about": [
      "Soy Ingeniero en Informática (INACAP) con formación Full Stack JavaScript (Desafío Latam). Construyo el producto completo: interfaces en React, apps en React Native, APIs en NestJS y la infraestructura que las sostiene en Google Cloud. Incluso lancé un videojuego 3D en Steam y Google Play.",
      "La mayor parte de mi experiencia reciente está en el backend: contratos de API claros, validación estricta y datos bien modelados. Sumado al frontend y mobile, eso me permite tomar un problema, diseñar la solución de punta a punta y llevarla a producción."
    ],
    "aboutFacts": [
      [
        "Rol",
        "Full Stack Developer"
      ],
      [
        "Backend y cloud",
        "NestJS · Node.js · Google Cloud"
      ],
      [
        "Frontend y mobile",
        "React · React Native · Expo"
      ],
      [
        "Formación",
        "Ingeniería en Informática · INACAP"
      ]
    ],
    "photo": "Foto profesional",
    "photoHint": "4:5, fondo neutro oscuro, luz lateral",
    "projEyebrow": "Proyectos",
    "projTitle": "Productos que puedes ver, usar y descargar",
    "projLead": "Web, mobile, backend y un juego publicado. Pasa el cursor por cada uno para ver más.",
    "projects": {
      "iac": {
        "kicker": "Healthtech · IA · Backend",
        "title": "IAClinical",
        "impact": "Microservicios de conversión de voz y de auditoría clínica diseñados desde cero, infraestructura en Google Cloud y mensajería por WhatsApp.",
        "details": [
          "2 microservicios diseñados desde cero",
          "Subida directa a Cloud Storage con URLs firmadas",
          "WhatsApp vía Twilio"
        ]
      },
      "roam": {
        "kicker": "Videojuego · Lanzamiento comercial",
        "title": "Roam Survival",
        "impact": "Juego de supervivencia 3D publicado en Steam y Google Play, de la idea al lanzamiento.",
        "details": [
          "De la idea al lanzamiento",
          "Unreal Engine 4 y Blueprints",
          "Modelado 3D en Blender"
        ]
      },
      "roperito": {
        "kicker": "Web · Marketplace · Tiempo real",
        "title": "Roperito",
        "impact": "Marketplace de ropa usada con autenticación, publicaciones y chat en tiempo real.",
        "details": [
          "Autenticación de usuarios",
          "Publicaciones de prendas",
          "Chat en tiempo real con Socket.io"
        ]
      },
      "tenapp": {
        "kicker": "Mobile · Pagos",
        "title": "Tenapp",
        "impact": "App para gestionar circuitos y torneos de tenis: inscripciones, cuadros, rankings y pagos con MercadoPago.",
        "details": [
          "Inscripciones y cuadros",
          "Rankings de jugadores",
          "Pagos con MercadoPago"
        ]
      },
      "checkauto": {
        "kicker": "Mobile",
        "title": "CheckAuto",
        "impact": "Gestión vehicular con recordatorios y notificaciones push.",
        "details": [
          "Gestión de vehículos",
          "Notificaciones push"
        ]
      },
      "others": {
        "kicker": "Más proyectos",
        "title": "BullRunFrenzy · Mamma Mía",
        "impact": "Un videojuego multijugador en desarrollo y un e-commerce completo de pizzería."
      }
    },
    "l": {
      "demo": "Demo",
      "code": "Código",
      "case": "Caso de estudio",
      "private": "Código privado"
    },
    "expEyebrow": "Experiencia",
    "expTitle": "Dónde he entregado",
    "stackEyebrow": "Stack",
    "stackTitle": "Herramientas con las que construyo",
    "stackLead": "Resaltado: lo que uso a diario, del frontend a la nube.",
    "wayEyebrow": "Formas de trabajar",
    "wayTitle": "Cómo trabajo",
    "ways": [
      {
        "icon": "rocket",
        "title": "Del frontend al backend",
        "text": "Construyo la interfaz, la API y la infraestructura, y dejo el producto corriendo con CI y deploy."
      },
      {
        "icon": "shield",
        "title": "Bases sólidas",
        "text": "Contratos de API claros, validación estricta y datos bien modelados sostienen todo lo demás."
      },
      {
        "icon": "realtime",
        "title": "Tiempo real e integraciones",
        "text": "WebSockets, SSE y Socket.io; WhatsApp con Twilio, pagos con MercadoPago y APIs documentadas con OpenAPI."
      },
      {
        "icon": "gamepad",
        "title": "Mentalidad de producto",
        "text": "He lanzado productos propios —incluido un juego en Steam y Google Play—, así que pienso en quien lo usa, no solo en el endpoint."
      }
    ],
    "contactEyebrow": "Contacto",
    "contactTitle": "¿Construimos algo?",
    "contactLead": "Busco equipos que necesiten a alguien capaz de construir un producto completo, del frontend al backend.",
    "copy": "Copiar",
    "copied": "Copiado",
    "footer": "Diseñado y desarrollado por Bryan Riveros"
  },
  "en": {
    "nav": [
      {
        "href": "#proyectos",
        "label": "Projects"
      },
      {
        "href": "#experiencia",
        "label": "Experience"
      },
      {
        "href": "#stack",
        "label": "Stack"
      },
      {
        "href": "#contacto",
        "label": "Contact"
      }
    ],
    "cv": "Download CV",
    "status": "Available for new projects",
    "heroA": "I build",
    "heroEm": "complete products",
    "heroB": ", from frontend to backend.",
    "heroSub": "Full Stack Developer with a solid backend foundation. React, React Native, NestJS and Google Cloud.",
    "ctaProjects": "View projects",
    "ctaContact": "Get in touch",
    "heroMeta": [
      "React",
      "React Native",
      "NestJS",
      "TypeScript",
      "Google Cloud"
    ],
    "stats": [
      {
        "value": "Web · Mobile · Backend",
        "label": "Real full stack: interface, app and API."
      },
      {
        "value": "2 apps and 1 game",
        "label": "published in stores."
      },
      {
        "value": "Google Cloud",
        "label": "Projects in production on Cloud Run, Cloud SQL and Cloud Storage."
      },
      {
        "value": "2+ years",
        "label": "of development experience."
      }
    ],
    "aboutEyebrow": "About",
    "aboutTitle": "Full stack product developer: interface, API and infrastructure.",
    "about": [
      "I’m a Computer Engineer (INACAP) with Full Stack JavaScript training (Desafío Latam). I build the whole product: React interfaces, React Native apps, NestJS APIs and the Google Cloud infrastructure behind them. I even shipped a 3D video game on Steam and Google Play.",
      "Most of my recent experience is on the backend: clear API contracts, strict validation and well-modeled data. Together with frontend and mobile, that lets me take a problem, design the solution end to end and ship it."
    ],
    "aboutFacts": [
      [
        "Role",
        "Full Stack Developer"
      ],
      [
        "Backend & cloud",
        "NestJS · Node.js · Google Cloud"
      ],
      [
        "Frontend & mobile",
        "React · React Native · Expo"
      ],
      [
        "Education",
        "Computer Engineering · INACAP"
      ]
    ],
    "photo": "Professional photo",
    "photoHint": "4:5, dark neutral background, side light",
    "projEyebrow": "Projects",
    "projTitle": "Products you can see, use and download",
    "projLead": "Web, mobile, backend and a published game. Hover each one to see more.",
    "projects": {
      "iac": {
        "kicker": "Healthtech · AI · Backend",
        "title": "IAClinical",
        "impact": "Voice conversion and clinical audit microservices designed from scratch, Google Cloud infrastructure and WhatsApp messaging.",
        "details": [
          "2 microservices designed from scratch",
          "Direct uploads to Cloud Storage with signed URLs",
          "WhatsApp via Twilio"
        ]
      },
      "roam": {
        "kicker": "Video game · Commercial release",
        "title": "Roam Survival",
        "impact": "3D survival game published on Steam and Google Play, from idea to launch.",
        "details": [
          "From idea to launch",
          "Unreal Engine 4 and Blueprints",
          "3D modeling in Blender"
        ]
      },
      "roperito": {
        "kicker": "Web · Marketplace · Real-time",
        "title": "Roperito",
        "impact": "Second-hand clothing marketplace with auth, listings and real-time chat.",
        "details": [
          "User authentication",
          "Clothing listings",
          "Real-time chat with Socket.io"
        ]
      },
      "tenapp": {
        "kicker": "Mobile · Payments",
        "title": "Tenapp",
        "impact": "App to run tennis circuits and tournaments: sign-ups, draws, rankings and MercadoPago payments.",
        "details": [
          "Sign-ups and draws",
          "Player rankings",
          "MercadoPago payments"
        ]
      },
      "checkauto": {
        "kicker": "Mobile",
        "title": "CheckAuto",
        "impact": "Vehicle management with reminders and push notifications.",
        "details": [
          "Vehicle management",
          "Push notifications"
        ]
      },
      "others": {
        "kicker": "More projects",
        "title": "BullRunFrenzy · Mamma Mía",
        "impact": "A multiplayer video game in development and a full pizzeria e-commerce."
      }
    },
    "l": {
      "demo": "Demo",
      "code": "Code",
      "case": "Case study",
      "private": "Private code"
    },
    "expEyebrow": "Experience",
    "expTitle": "Where I’ve shipped",
    "stackEyebrow": "Stack",
    "stackTitle": "Tools I build with",
    "stackLead": "Highlighted: what I use daily, from frontend to cloud.",
    "wayEyebrow": "How I work",
    "wayTitle": "How I work",
    "ways": [
      {
        "icon": "rocket",
        "title": "From frontend to backend",
        "text": "I build the interface, the API and the infrastructure, and leave the product running with CI and deploys."
      },
      {
        "icon": "shield",
        "title": "Solid foundations",
        "text": "Clear API contracts, strict validation and well-modeled data hold everything else up."
      },
      {
        "icon": "realtime",
        "title": "Real-time and integrations",
        "text": "WebSockets, SSE and Socket.io; WhatsApp with Twilio, MercadoPago payments and APIs documented with OpenAPI."
      },
      {
        "icon": "gamepad",
        "title": "Product mindset",
        "text": "I’ve shipped my own products —including a game on Steam and Google Play— so I think about who uses it, not just the endpoint."
      }
    ],
    "contactEyebrow": "Contact",
    "contactTitle": "Shall we build something?",
    "contactLead": "I’m looking for teams that need someone who can build a complete product, from frontend to backend.",
    "copy": "Copy",
    "copied": "Copied",
    "footer": "Designed and built by Bryan Riveros"
  }
};

export const EXPERIENCE = {
  "es": [
    {
      "company": "IAClinical",
      "org": "Salud y Asistencia Médica Digital SpA",
      "role": "Backend Developer Junior",
      "dates": "11/2025 — actualidad",
      "current": true,
      "wins": [
        {
          "verb": "Diseñé y construí 2 microservicios desde cero",
          "text": "—conversión de voz para flujos con IA y auditoría clínica con asignación automática a especialistas— y contribuí al desarrollo de varios microservicios más de la plataforma."
        },
        {
          "verb": "Trabajo en infraestructura sobre Google Cloud:",
          "text": "Cloud Run, Cloud SQL, Cloud Storage y Cloud Scheduler, más Docker."
        },
        {
          "verb": "Integré mensajería por WhatsApp",
          "text": "con Twilio."
        },
        {
          "verb": "Rediseñé el sistema de subida de archivos",
          "text": "con URLs firmadas: el frontend sube directo a Cloud Storage y el backend solo recibe los datos del registro."
        }
      ],
      "stack": [
        "NestJS",
        "TypeScript",
        "PostgreSQL",
        "Cloud Run",
        "Cloud SQL",
        "Docker",
        "Twilio"
      ],
      "highlight": {
        "title": "Mini caso: subida de archivos con URLs firmadas",
        "before": {
          "steps": [
            {
              "icon": "phone",
              "text": "El frontend enviaba el archivo completo al backend."
            },
            {
              "icon": "server",
              "text": "El backend lo recibía, lo procesaba y lo subía a Cloud Storage."
            },
            {
              "icon": "hourglass",
              "text": "Cada subida ocupaba memoria y tiempo del servidor."
            }
          ]
        },
        "after": {
          "steps": [
            {
              "icon": "key",
              "text": "El backend entrega una URL firmada de corta duración."
            },
            {
              "icon": "upload",
              "text": "El frontend sube el archivo directo a Cloud Storage."
            },
            {
              "icon": "database",
              "text": "El backend solo recibe y guarda los datos del registro."
            }
          ]
        },
        "result": "Menos carga en el servidor y subidas más rápidas."
      }
    },
    {
      "company": "Tenapp",
      "role": "Desarrollador React Native",
      "dates": "01/2025 — 09/2025",
      "wins": [
        {
          "verb": "Construí",
          "text": "una app móvil para gestionar circuitos y torneos de tenis: inscripciones, cuadros, rankings y resultados en un solo lugar."
        },
        {
          "verb": "Integré",
          "text": "MercadoPago para el cobro de inscripciones."
        },
        {
          "verb": "Usé",
          "text": "Expo y Firebase como base de la app y su backend."
        }
      ],
      "stack": [
        "React Native",
        "Expo",
        "Firebase",
        "MercadoPago"
      ]
    },
    {
      "company": "JYF Industrial",
      "role": "Desarrollador Mobile",
      "dates": "01/2021 — 08/2021",
      "wins": [
        {
          "verb": "Digitalicé",
          "text": "la gestión interna y los inventarios con una app móvil."
        },
        {
          "verb": "Conecté",
          "text": "la app a bases de datos remotas en MySQL vía PHP, con SQLite en el dispositivo."
        }
      ],
      "stack": [
        "React Native",
        "MySQL",
        "SQLite",
        "PHP"
      ]
    }
  ],
  "en": [
    {
      "company": "IAClinical",
      "org": "Salud y Asistencia Médica Digital SpA",
      "role": "Backend Developer Junior",
      "dates": "11/2025 — present",
      "current": true,
      "wins": [
        {
          "verb": "Designed and built 2 microservices from scratch",
          "text": "—voice conversion for AI flows and clinical audit with automatic assignment to specialists— and contributed to several more microservices on the platform."
        },
        {
          "verb": "Work on Google Cloud infrastructure:",
          "text": "Cloud Run, Cloud SQL, Cloud Storage and Cloud Scheduler, plus Docker."
        },
        {
          "verb": "Integrated WhatsApp messaging",
          "text": "with Twilio."
        },
        {
          "verb": "Redesigned the file upload system",
          "text": "with signed URLs: the frontend uploads straight to Cloud Storage and the backend only receives the record data."
        }
      ],
      "stack": [
        "NestJS",
        "TypeScript",
        "PostgreSQL",
        "Cloud Run",
        "Cloud SQL",
        "Docker",
        "Twilio"
      ],
      "highlight": {
        "title": "Mini case: file uploads with signed URLs",
        "before": {
          "steps": [
            {
              "icon": "phone",
              "text": "The frontend sent the whole file to the backend."
            },
            {
              "icon": "server",
              "text": "The backend received it, processed it and uploaded it to Cloud Storage."
            },
            {
              "icon": "hourglass",
              "text": "Every upload used server memory and time."
            }
          ]
        },
        "after": {
          "steps": [
            {
              "icon": "key",
              "text": "The backend returns a short-lived signed URL."
            },
            {
              "icon": "upload",
              "text": "The frontend uploads the file straight to Cloud Storage."
            },
            {
              "icon": "database",
              "text": "The backend only receives and stores the record data."
            }
          ]
        },
        "result": "Less load on the server and faster uploads."
      }
    },
    {
      "company": "Tenapp",
      "role": "Desarrollador React Native",
      "dates": "01/2025 — 09/2025",
      "wins": [
        {
          "verb": "Construí",
          "text": "una app móvil para gestionar circuitos y torneos de tenis: inscripciones, cuadros, rankings y resultados en un solo lugar."
        },
        {
          "verb": "Integré",
          "text": "MercadoPago para el cobro de inscripciones."
        },
        {
          "verb": "Usé",
          "text": "Expo y Firebase como base de la app y su backend."
        }
      ],
      "stack": [
        "React Native",
        "Expo",
        "Firebase",
        "MercadoPago"
      ]
    },
    {
      "company": "JYF Industrial",
      "role": "Desarrollador Mobile",
      "dates": "01/2021 — 08/2021",
      "wins": [
        {
          "verb": "Digitalicé",
          "text": "la gestión interna y los inventarios con una app móvil."
        },
        {
          "verb": "Conecté",
          "text": "la app a bases de datos remotas en MySQL vía PHP, con SQLite en el dispositivo."
        }
      ],
      "stack": [
        "React Native",
        "MySQL",
        "SQLite",
        "PHP"
      ]
    }
  ]
};

export const STACK = [
  {
    "name": "Backend",
    "icon": "server",
    "primary": true,
    "items": [
      {
        "name": "NestJS",
        "core": true
      },
      {
        "name": "TypeScript",
        "core": true
      },
      {
        "name": "Node.js",
        "core": true
      },
      "Express",
      "Java",
      "Spring Boot"
    ]
  },
  {
    "name": "Frontend / Mobile",
    "icon": "browser",
    "primary": true,
    "items": [
      {
        "name": "React",
        "core": true
      },
      {
        "name": "React Native",
        "core": true
      },
      {
        "name": "Expo",
        "core": true
      }
    ]
  },
  {
    "name": "Cloud y DevOps",
    "icon": "cloud",
    "items": [
      {
        "name": "Google Cloud",
        "core": true
      },
      {
        "name": "Cloud Run",
        "core": true
      },
      "Cloud SQL",
      "Cloud Storage",
      "Cloud Scheduler",
      "Docker"
    ]
  },
  {
    "name": "Datos",
    "icon": "database",
    "items": [
      {
        "name": "PostgreSQL",
        "core": true
      },
      "MySQL",
      "Firestore"
    ]
  },
  {
    "name": "Tiempo real",
    "icon": "realtime",
    "items": [
      "WebSockets",
      "SSE",
      "Socket.io"
    ]
  },
  {
    "name": "Integraciones",
    "icon": "plug",
    "wide": true,
    "items": [
      "REST",
      "Swagger / OpenAPI",
      "Twilio",
      "MercadoPago"
    ]
  },
  {
    "name": "Workflow",
    "icon": "pr",
    "wide": true,
    "items": [
      "GitHub",
      "Pull Requests",
      "Jira",
      "Scrum / Kanban"
    ]
  }
];
